/**
 * @params string url
 * @return boolean is Web Protocol
 * can detect string starts with http, https, //
 * */
module.exports = function (url) {
    return /^http:|^https:|^\/\//i.test(url);
};



// WEBPACK FOOTER //
// ./~/@dp/knb/compiled/common/web-protocol.js